import { Component, Input } from '@angular/core';
import { ProgressBarGroup } from '@app/core/models';

@Component({
  selector: 'app-rc-progress-bar',
  templateUrl: './rc-progress-bar.component.html',
  styleUrls: ['./rc-progress-bar.component.scss'],
  standalone: true,
})
export class RcProgressBarComponent {
  @Input() groups: ProgressBarGroup[] = [];
}
